export const PUBLIC_PORTAL_API_PREFIX = "publicportal/";
